// extracted by mini-css-extract-plugin
export default {"icon":"index_icon__Meba6","iconStyled":"index_iconStyled__7VG9w","square":"index_square__woCj4"};